if ( typeof ToggleTab !== 'function' ) {

	class ToggleTab extends HTMLElement {

		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';

			this.titleEl = this.querySelector('[data-js-title]');
			this.contentEl = this.querySelector('[data-js-content]');
			this.titleEl.innerHTML = `${this.titleEl.innerHTML}${this.hasAttribute('data-togglepack-alternate') ? KROWN.settings.symbols.toggle_pack_alternate : KROWN.settings.symbols.toggle_pack}`;

			if ( this.hasAttribute('data-toggle-inert') ) {
				this.toggleInert = true;
			}

			this.titleEl.addEventListener('click',this.onClickHandler.bind(this));
			this.titleEl.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.onClickHandler();
				}
			})

		}
		
		onClickHandler(){
			if ( ! this.classList.contains(`${this._prefix}opened`) ) {
				this.classList.add(`${this._prefix}opened`);
				this.titleEl.setAttribute('aria-expanded', 'true');
				this.#slideDown(this.contentEl, 200);
				if ( this.toggleInert ) {
					this.contentEl.removeAttribute('inert');
				}
				setTimeout(()=>{
					this.contentEl.querySelector('css-slider')?.resetSlider();
				}, 200);
			} else {
				this.classList.remove(`${this._prefix}opened`);
				this.titleEl.setAttribute('aria-expanded', 'false');
				if ( this.toggleInert ) {
					this.contentEl.setAttribute('inert', '');
				}
				this.#slideUp(this.contentEl, 200);
			}
		}

		#slideUp(target, duration){
			target.style.transitionProperty = 'height, margin, padding';
			target.style.transitionDuration = duration + 'ms';
			target.style.boxSizing = 'border-box';
			target.style.height = target.offsetHeight + 'px';
			target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			setTimeout(()=>{
				target.style.display = 'none';
				target.style.removeProperty('height');
				target.style.removeProperty('padding-top');
				target.style.removeProperty('padding-bottom');
				target.style.removeProperty('margin-top');
				target.style.removeProperty('margin-bottom');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}
		#slideDown(target, duration) {
			target.style.removeProperty('display');
			var display = window.getComputedStyle(target).display;

			if (display === 'none')
				display = 'block';

			target.style.display = display;
			var height = target.offsetHeight;
			target.style.overflow = 'hidden';
			target.style.height = 0;
			target.style.paddingTop = 0;
			target.style.paddingBottom = 0;
			target.style.marginTop = 0;
			target.style.marginBottom = 0;
			target.offsetHeight;
			target.style.boxSizing = 'border-box';
			target.style.transitionProperty = "height, margin, padding";
			target.style.transitionDuration = duration + 'ms';
			target.style.height = height + 'px';
			target.style.removeProperty('padding-top');
			target.style.removeProperty('padding-bottom');
			target.style.removeProperty('margin-top');
			target.style.removeProperty('margin-bottom');
			setTimeout(()=>{
				target.style.removeProperty('height');
				target.style.removeProperty('overflow');
				target.style.removeProperty('transition-duration');
				target.style.removeProperty('transition-property');
			}, duration);
		}

	}

  if ( typeof customElements.get('toggle-tab') == 'undefined' ) {
		customElements.define('toggle-tab', ToggleTab);
	}

}

if ( typeof ToggleGroup !== 'function' ) {

	class ToggleGroup extends HTMLElement {

		constructor(){

			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelectorAll('toggle-tab').forEach(allToggle=>{
				allToggle.querySelector('[data-js-title]').addEventListener('click', ()=>{
					this.querySelectorAll(`toggle-tab.${this._prefix}opened`).forEach(openedToggle=>{
						if ( allToggle !== openedToggle ) {
							openedToggle.onClickHandler();
						}
					});
				});
			});

		}

	}
	
  if ( typeof customElements.get('toggle-group') == 'undefined' ) {
		customElements.define('toggle-group', ToggleGroup);
	}

}

(function() {
  const faqOverrides = {
    content_toggles_mHEpAr: [
      {
        title: 'How fresh are the meals and how long do they last?',
        body: '<p>Our meals are freshly chef-prepared, sealed for freshness, and delivered or shipped cold. Keep meals refrigerated and enjoy them within 7 days of receiving them. Once opened, consume within 3 to 4 days for the best freshness.</p>'
      },
      {
        title: 'How long do the meals last in the fridge?',
        body: '<p>Keep meals refrigerated. Unopened meals are best enjoyed within 7 days of receiving them. Once a container has been opened, consume it within 3 to 4 days for the best taste, texture, and freshness.</p>'
      },
      {
        title: 'Can you freeze the meals?',
        body: '<p>Many meals may be frozen for longer storage, although texture and quality can vary depending on the ingredients. Keep the container sealed, freeze before the use-by window ends, and follow any meal-specific freezing instructions provided.</p>'
      },
      {
        title: 'How long do meals stay fresh in the freezer?',
        body: '<p>For best quality, use frozen meals within about 2 to 3 months. Thaw overnight in the refrigerator before reheating. Some ingredients freeze better than others, so texture may vary by meal.</p>'
      },
      {
        title: 'Are the ingredients fresh?',
        body: '<p>Yes. Our meals are chef-prepared with fresh, quality ingredients, including lean proteins, produce, Mediterranean-inspired seasonings, and better-for-you cooking oils like avocado oil where used. Meals are sealed and kept cold to protect freshness.</p>'
      },
      {
        title: 'Are there allergy-friendly meal prep options?',
        body: '<p>Yes. You can use the Filter and Sort options on the menu to find meals marked gluten-free, dairy-free, soy-free, low carb, keto friendly, vegetarian, vegan friendly, and more. Please always review the product ingredients and allergen notes before ordering, especially if you have a severe allergy.</p>'
      },
      {
        title: 'Is the meat halal?',
        body: '<p>Yes. Our meats are Halal certified, including chicken, turkey, turkey bacon, steak, and ground beef. You can view our Halal certification here: <a href="https://cdn.shopify.com/s/files/1/0611/0239/1543/files/halal_cert.pdf?v=1746052749" target="_blank" rel="noopener">Halal certification</a>.</p>'
      },
      {
        title: 'Are sauces included in the macros?',
        body: '<p>Yes. The macros shown for each meal include the sauces that come with that meal, so you do not need to calculate them separately.</p>'
      },
      {
        title: 'How many servings are in a meal prep container?',
        body: '<p>Most individual meal prep containers are one ready-to-eat meal. Larger bulk or a la carte items may contain multiple servings, so check the product page, label, and nutrition information for that specific item.</p>'
      },
      {
        title: 'Do you offer catering?',
        body: '<p>Yes. For catering, email <a href="mailto:hummusfit@gmail.com">hummusfit@gmail.com</a> with your event details, date, location, and what you are looking for. Our team will help guide you through the options.</p>'
      },
      {
        title: 'How do I heat and prepare the meals?',
        body: '<p>Remove any labels, foil stickers, and sauces before heating. Transfer to a microwave-safe dish if needed, then heat for about 2 minutes. Stir, check the temperature, and add 30-second intervals until heated through.</p>'
      },
      {
        title: 'How do I reheat meals from the fridge or freezer?',
        body: '<p>For refrigerated meals, microwave for about 2 minutes, then stir and add 30-second intervals as needed. For frozen meals, thaw overnight in the refrigerator first for the best texture, then reheat the same way.</p>'
      },
      {
        title: 'How should I store the meals?',
        body: '<p>Keep meals refrigerated until you are ready to eat. Once opened, consume within 3 to 4 days for the best freshness. Many meals may be frozen for longer storage, although texture and quality can vary depending on the ingredients.</p>'
      }
    ],
    content_toggles_UFheL8: [
      {
        title: 'How long do Liana\'s Buffin Muffins last after purchasing?',
        body: '<p>Buffin Muffins are best kept refrigerated and enjoyed within 14 days. Muffins without filling may be kept at room temperature for up to 7 days if sealed. For longer storage, freeze them in a sealed freezer bag.</p>'
      },
      {
        title: 'Can you freeze Liana\'s Buffin Muffins?',
        body: '<p>Yes. Freeze Buffin Muffins in a sealed freezer bag or airtight container for up to 60 days. Thaw in the refrigerator or warm gently when you are ready to enjoy them.</p>'
      },
      {
        title: 'What is the shelf life of the muffins?',
        body: '<p>Buffin Muffins last up to 14 days in the fridge and up to 60 days in the freezer. If the muffin does not have filling, it may be kept sealed at room temperature for up to 7 days. Always check the sell-by date on the package.</p>'
      },
      {
        title: 'Are the muffins delivered frozen?',
        body: '<p>Buffin Muffins are made fresh and shipped or delivered cold in insulated packaging. They are not meant to arrive frozen, but they should be refrigerated when you receive them.</p>'
      },
      {
        title: 'Is there added sugar in the muffins or oats?',
        body: '<p>We do not add regular sugar to our Buffin Muffins or overnight oats. We use sweeteners such as Truvia, Brown Sugar Truvia, stevia, and erythritol depending on the item. Always check the product nutrition and ingredient panel for the exact details.</p>'
      },
      {
        title: 'Are any muffins dairy-free, lactose-free, or gluten-free?',
        body: '<p>We offer gluten-free muffin options. Our standard Buffin Muffins are not dairy-free or lactose-free unless a specific product says so. View gluten-free muffins here: <a href="https://myhummusfit.com/products/gluten-free-muffin" target="_blank" rel="noopener">Gluten-Free Muffin</a>.</p>'
      },
      {
        title: 'Do the muffins use alternative sweeteners?',
        body: '<p>Yes. Buffin Muffins may use alternative sweeteners such as stevia, Truvia, and erythritol to keep them sweet without added sugar. Check each product page for the exact ingredients.</p>'
      }
    ],
    content_toggles_fipc9R: [
      {
        title: 'How long are the oats good for once opened?',
        body: '<p>Once opened, keep overnight oats refrigerated and consume within 3 to 4 days for the best freshness.</p>'
      },
      {
        title: 'How long do overnight oats last in the fridge?',
        body: '<p>Unopened overnight oats should stay refrigerated and be enjoyed by the date on the package. For best quality, keep the container sealed until you are ready to eat.</p>'
      },
      {
        title: 'Are there any snacks that are gluten-free?',
        body: '<p>Yes. We offer gluten-free snack options, including select Buffin Muffins. Use the gluten-free collection or Filter and Sort tools, and always review each product page for ingredients and allergen notes.</p>'
      },
      {
        title: 'Are overnight oats considered meals?',
        body: '<p>Overnight oats can work as a quick breakfast, snack, or lighter meal depending on your goals and macros. Check the nutrition information to see how they fit into your plan.</p>'
      },
      {
        title: 'How do you ship snacks so they stay fresh?',
        body: '<p>Snacks are packed in sealed containers and shipped in insulated packaging with cold packs or dry ice when needed. Refrigerate per the product instructions once your order arrives.</p>'
      }
    ],
    content_toggles_HU9336: [
      {
        title: 'Do all Hummus Fit locations offer pickup?',
        body: '<p>Yes. Pickup is available at all Hummus Fit locations. You can order online for pickup or walk in during store hours to grab fresh meals, Buffin Muffins, and snacks. Availability can vary by location.</p><p><strong>See our locations here:</strong> <a href="https://myhummusfit.com/pages/contact" target="_blank" rel="noopener">https://myhummusfit.com/pages/contact</a></p>'
      },
      {
        title: 'How can I check if I am eligible for local delivery?',
        body: '<p>Add your items to cart and continue to checkout with your delivery address. If your Long Island address is eligible, the $15 local delivery option will appear at checkout.</p>'
      },
      {
        title: 'Can I pick up individual meals in stores at any time?',
        body: '<p>Yes. You can walk into any Hummus Fit location during store hours and purchase individual meals or snacks. Store inventory changes throughout the day, so selection may vary.</p>'
      },
      {
        title: 'How far do you deliver locally?',
        body: '<p>Local delivery is available in Nassau and Suffolk counties on Long Island. Enter your address at checkout to confirm availability for your location.</p>'
      },
      {
        title: 'How much is local Long Island delivery?',
        body: '<p>Local Long Island delivery is a $15 flat fee for eligible Nassau and Suffolk county addresses.</p>'
      },
      {
        title: 'What if I am not home for my local delivery?',
        body: '<p>You will receive a text when your driver is on the way. If you are not home, the order may be left in a safe place. Please refrigerate your meals as soon as possible after delivery.</p>'
      },
      {
        title: 'Do you ship to Canada?',
        body: '<p>Yes. We ship to Canada, all 50 U.S. states, and Puerto Rico. Available shipping options and final costs are shown at checkout.</p>'
      },
      {
        title: 'Do you ship to California, Florida, or other states?',
        body: '<p>Yes. We ship nationwide through UPS, including California, Florida, and all other U.S. states. Local Long Island delivery is also available for eligible Nassau and Suffolk county addresses.</p>'
      },
      {
        title: 'Local Delivery & Pickup Options',
        body: '<h4><strong>Local Long Island Delivery</strong></h4><p>Local delivery is available in eligible Nassau and Suffolk county areas for a $15 flat fee. Deliveries are made on Sundays. Order by <strong>Friday at 11:59 PM</strong> for that Sunday delivery.</p><h4><strong>Same-Day Pickup</strong></h4><p>Pickup is free at all Hummus Fit locations. Orders placed during store hours are generally ready within about 2 hours, and you will receive an email when your order is ready.</p>'
      },
      {
        title: 'Shipping Schedule & Zones',
        body: '<p>We ship from New York using UPS. Shipping method and ship day depend on your distance from us and the time your order is placed. The shipping schedule and zone map below this FAQ show the most accurate estimate for your order.</p>'
      },
      {
        title: 'Weekend Shipping Policy',
        body: '<p>We avoid shipping orders into weekend delays so meals stay fresh. Depending on your zone and shipping method, orders placed late Thursday or Friday may ship the following Monday.</p>'
      },
      {
        title: 'Standard Shipping Details (US)',
        body: '<p>Orders are usually processed within <strong>24 to 48 business hours</strong>. Most shipments go out Monday through Thursday through UPS in insulated packaging with dry ice or cold protection as needed.</p><p>You will receive tracking once your order ships. UPS transit times vary by zone, shipping method, weather, and carrier conditions.</p><p><strong>Dry ice notice:</strong> Most shipments contain dry ice (-78.5&deg;C / -109.3&deg;F). Handle with care, avoid direct skin contact, keep the package ventilated, and do not consume dry ice.</p>'
      },
      {
        title: 'Shipping Costs',
        body: '<p><strong>Local Long Island Delivery:</strong> $15 flat fee for eligible Nassau and Suffolk county addresses.</p><p><strong>Standard Shipping:</strong> Most U.S. shipping rates range from <strong>$19.99 to $29.99</strong> depending on location and speed.</p><p><strong>Canada and Puerto Rico:</strong> Available options and final rates are shown at checkout.</p>'
      }
    ]
  };

  function applyFaqOverrides() {
    Object.keys(faqOverrides).forEach(sectionKey => {
      const section = document.querySelector(`[id$="__${sectionKey}"]`);

      if (!section) {
        return;
      }

      section.querySelectorAll('toggle-tab').forEach((tab, index) => {
        const override = faqOverrides[sectionKey][index];

        if (!override) {
          return;
        }

        const title = tab.querySelector('.toggle__heading .text-weight--bold');
        const content = tab.querySelector('[data-js-content]');

        if (title) {
          title.textContent = override.title;
        }

        if (content) {
          content.innerHTML = override.body;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyFaqOverrides);
  } else {
    applyFaqOverrides();
  }
})();